// App utils
import axios from 'axios';
import { datajs, datajsAll, debounce } from '../shared/utils';

export default class SiteHeaderSearch {
	static init() {
		const adminUrl = window.AppGlobals.adminUrl;
		const baseUrl = window.AppGlobals.baseUrl;
		const siteHeaderSearchInput = datajs('site-header-search-input');
		const CancelToken = axios.CancelToken;
		let source = CancelToken.source();

		if (!siteHeaderSearchInput) {
			return;
		}

		const resetBtn = datajs('reset-searchform');
		const siteHeaderSearchFooter = datajs('site-search-footer');
		const gridContainer = datajs('site-search-result-container');
		const gridContainerWrapper = datajs('site-search-result-container-wrapper');
		const filterWrapper = datajs('site-header-search-filter-wrapper');
		const postsPerPage = siteHeaderSearchInput?.dataset?.postsPerPage || 12;

		const searchFilters = datajsAll('site-header-search-filter');
		const filterAll = datajs('site-header-search-all-filter');
		let filterState = [filterAll.value];
		let moreResultsLink = datajs('more-results-link');

		const setFilterAllState = () => {
			filterAll.checked = true;
			filterState = [filterAll.value];

			searchFilters.forEach((filter) => {
				filter.checked = false;
			});

			search();
		};

		const setFilterState = () => {
			filterState = [];

			searchFilters.forEach((filter) => {
				if (filter.checked) {
					filterState.push(filter.value);
				}
			});

			// If all or no filters are selected
			if (filterState.length === searchFilters.length || !filterState.length) {
				setFilterAllState();
				return;
			}

			filterAll.checked = false;
			search();
		};

		const updateFilterHitCount = (hitsObj) => {
			let li, pill, hits;
			searchFilters.forEach((filter) => {
				li = filter.closest('li');
				pill = datajs('pill', li);
				hits = hitsObj[li.dataset.postType];

				li.dataset.hits = hits;
				pill.dataset.hits = hits;
			});
		};

		const search = () => {
			const params = new URLSearchParams();
			let searchInput = siteHeaderSearchInput.value;
			moreResultsLink.href = `${baseUrl}?s=${searchInput}`;
			source = axios.CancelToken.source();

			if (!gridContainer) {
				console.error('A valid container to populate with the search result is not defined');
				return;
			}

			// Empty search input
			if (searchInput === '') {
				gridContainer.innerHTML = '';
				siteHeaderSearchFooter.classList.add('d-none');
				filterWrapper.classList.add('d-none');
				return;
			}

			params.append('action', 'site_search');
			params.append('s', searchInput);
			params.append('post_types', filterState.toString());

			gridContainerWrapper.classList.add('is-searching');
			siteHeaderSearchFooter.classList.add('d-none');

			axios
				.post(`${adminUrl}admin-ajax.php`, params, { cancelToken: source.token })
				.then((res) => {
					// Apply result
					if (res.data.success) {
						if (res.data.data.count > 0) {
							filterWrapper.classList.remove('d-none');
							gridContainer.innerHTML = res.data.data.html;
						} else {
							filterWrapper.classList.add('d-none');
							gridContainer.innerHTML = '<p class="no-results">Inga resultat</p>';
						}

						// Update filter hit count
						updateFilterHitCount(res.data.data.individual_post_type_hit_count);

						// Show more results link if necessary
						if (res.data.data.count >= postsPerPage) {
							siteHeaderSearchFooter.classList.remove('d-none');
						}
					}
				})
				.catch((error) => {
					if (error.code !== 'ERR_CANCELED') {
						console.error(error.code);
					}
				})
				.finally(() => {
					gridContainerWrapper.classList.remove('is-searching');
				});
		};

		const debouncedSearch = debounce(search, 500);

		const resetForm = () => {
			siteHeaderSearchInput.value = '';
			siteHeaderSearchInput.setAttribute('value', '');
			search();
			return false;
		};

		// Reset
		resetBtn?.addEventListener('click', resetForm);

		// Input
		siteHeaderSearchInput?.addEventListener('input', function () {
			source && source.cancel('Operation canceled due to new request.');
			debouncedSearch();
		});

		// Trigger search once initially if search input has value
		if (siteHeaderSearchInput.value !== '') {
			siteHeaderSearchInput?.addEventListener('focus', debouncedSearch, { once: true });
		}

		// Filter Change
		searchFilters?.forEach((input) => {
			input.addEventListener('change', setFilterState);
		});

		// Filter All Change
		filterAll.addEventListener('change', setFilterAllState);
	}
}
